import type { DynamicBaseQueryFn } from '@nx/state';
import type { EndpointBuilder } from '@reduxjs/toolkit/query/react';

export const NAME = 'shared-storage-api';

export const TAG_TYPES = {
  SavedCypherTree: 'SavedCypherTree',
  Item: 'Item',
} as const;

export const tagTypes = Object.values(TAG_TYPES);

export type TagType = (typeof tagTypes)[number];

export type QueryEndpointBuilder = EndpointBuilder<DynamicBaseQueryFn, TagType, typeof NAME>;

export const makeTag = <T extends TagType>(type: T, ...identifiers: (string | number)[]) => {
  return identifiers.length > 0 ? { type, id: identifiers.join(':') } : type;
};
